import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white px-4 py-4 sm:px-6 sm:py-5" aria-labelledby="testimonials-heading" data-id="element-132" data-mp="3kqw54mwtl6h6">
      <div className="mb-2.5 text-center" data-id="element-133" data-mp="3fy316196e265">
        <h2 id="testimonials-heading" className="mb-0.5 text-[19px] font-extrabold uppercase leading-tight text-brand-navy sm:text-3xl" data-id="element-134" data-mp="3b0krg8nc3ix3">
          Cosa Dicono gli Istruttori
        </h2>
        <p className="font-heading text-[11px] font-extrabold uppercase tracking-wide text-brand-green sm:text-xs" data-id="element-135" data-mp="31zd1qeyvvqem">
          Recensioni verificate di istruttori e maestri di padel
        </p>
      </div>
      <div className="space-y-1.5" data-id="element-136" data-mp="2s2i4s0i9dy2g">
        {testimonials.map(testimonial => <article key={testimonial.author} className="rounded-lg border border-brand-navy/10 bg-brand-gray p-2.5 shadow-sm sm:p-3" data-id="element-137" data-mp="v96jbxhmprie">
            <div className="mb-1 flex gap-0.5" aria-label="5 stelle su 5" data-id="element-138" data-mp="q8915kwmcxgw">
              {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-3 w-3 fill-brand-green text-brand-green" aria-hidden="true" data-id="element-139" data-mp="m5kl4lwpipbd" />)}
            </div>
            <p className="mb-1.5 text-[11.5px] font-medium italic leading-snug text-brand-ink sm:text-xs" data-id="element-140" data-mp="c625uirqrrpn">
              “{testimonial.text}”
            </p>
            <div className="flex items-center gap-2 border-t border-brand-navy/10 pt-1.5" data-id="element-141" data-mp="zysfglc69ywr">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-brand-navy font-heading text-[11px] font-extrabold text-white" data-id="element-142" data-mp="14xde4gbs0aj3">
                {testimonial.author.charAt(0)}
              </span>
              <div data-id="element-143" data-mp="1ivk4zcib5a99">
                <p className="text-[11px] font-extrabold text-brand-navy" data-id="element-144" data-mp="1iv1xfjq739m1">— {testimonial.author}</p>
                <p className="text-[9px] font-semibold uppercase tracking-wide text-brand-muted" data-id="element-145" data-mp="1nma7mhzcmz09">
                  {testimonial.role} — {testimonial.location}
                </p>
              </div>
            </div>
          </article>)}
      </div>
    </section>;
}